import React from "react";
import KC_Heading3 from "../../../../designsystem/typography/KC-Heading/KC_Heading3";
import KC_Text from "../../../../designsystem/typography/KC_Text/KC_Text";
import { KC_Text_Sizes, KC_Weights } from "../../../../designsystem/ds_commons";
import useGLM from "../../../../utils/hooks/useGLM";
import { JetpackConfigAPI } from "../../api/JetpackConfigAPI";
import GLMCard from "./components/GLMCard";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";

export default function JetpackMLConfig() {
  const { accountToDisplay } = useAccountToDisplaySelector();
  const { GLMList, isLoading, error } = useGLM(
    accountToDisplay?.token,
    JetpackConfigAPI.getCommonML
  );
  return (
    <div
      className="p-4 border rounded d-flex flex-column st-gap"
      style={{ backgroundColor: "white" }}
    >
      <div>
        <KC_Heading3 text={"Mon calendrier de gros lots"} />
        <KC_Text
          size={KC_Text_Sizes.md}
          weight={KC_Weights.reg}
          text={
            "Voici la liste des gros lot que vos utilisateurs pourront gagner chaque mois"
          }
        />
      </div>
      <div className="ml-preview-container">
        {GLMList.map((glm, idx) => {
          return <GLMCard glm={glm} isUpsell={false} key={glm._id} />;
        })}
      </div>
    </div>
  );
}
